<template>
  <div>
    <div class="wrapper">
      <v-list>
        <v-list-tile
          v-for="(bulkAddType, index) in bulkAddTypes"
          :key="index"
          @click="clickMenu(bulkAddType)"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              {{ bulkAddType }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkAddMenuList',
  computed: {
    bulkAddTypes() {
      return ['グループ一括登録', 'グループ・地点一括登録']
    },
  },
  methods: {
    clickMenu(bulkAddType) {
      if (bulkAddType === 'グループ一括登録') {
        this.$emit('onClickMenu', 'group')
      }
      if (bulkAddType === 'グループ・地点一括登録') {
        this.$emit('onClickMenu', 'groupAndLocation')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  z-index: 10;
}
.button {
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>
